import { useQuery } from '@tanstack/react-query';

import { fetchIdpLegalAgreements } from '../api/fetchIdpLegalAgreements.js';
import { dosespotIdpKeys } from './keys.js';

export function idpLegalAgreementsQueryDefinition() {
  return {
    queryKey: dosespotIdpKeys.legalAgreements(),
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchIdpLegalAgreements(signal),
    meta: {
      toast: {
        title: 'Could not load legal agreements',
        description: 'The identity proofing legal agreements could not be fetched.',
      },
    },
  } as const;
}

export function useIdpLegalAgreementsQuery(options?: { enabled?: boolean }) {
  return useQuery({
    ...idpLegalAgreementsQueryDefinition(),
    enabled: options?.enabled,
  });
}
